// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6db3b77b","239":"b3360c5c","732":"9e0aae77"}[chunkId] + ".chunk.js";
};